import type { UseFormReturn } from 'react-hook-form';

import type { IDesignStoreFormShape } from '../StoreDetails/storeDetails.types';
import { STORE_CHECKOUT_BRANDING } from '../constants/storeCheckout.constants';

export const isDefaultFreshPrintStoreLogo = (logo: string | null | undefined): boolean => {
  const value = (logo ?? '').toString().trim();
  if (!value) {
    return true;
  }
  return (
    value === STORE_CHECKOUT_BRANDING.DEFAULT_FP_LOGO_SRC ||
    value.includes('/src/assets/png/fp.png') ||
    value.includes('fresh-prints-default-branding-logo')
  );
};

export const isUserUploadedStoreLogo = (logo: string | null | undefined): boolean => {
  const value = (logo ?? '').toString().trim();
  if (!value || isDefaultFreshPrintStoreLogo(value)) {
    return false;
  }
  return true;
};

export const isRemoteStoreLogoSrc = (logo: string | null | undefined): boolean =>
  /^https?:\/\//i.test((logo ?? '').toString().trim());

export const resolveStoreLogoPreviewSrc = (storeLogo: string): string | null => {
  if (isUserUploadedStoreLogo(storeLogo)) {
    return storeLogo;
  }
  return STORE_CHECKOUT_BRANDING.DEFAULT_FP_LOGO_SRC;
};

export const applyDefaultFreshPrintBrandingToForm = (
  designForm: UseFormReturn<IDesignStoreFormShape>,
  forceOverwrite = false
): void => {
  const logo = (designForm.getValues('storeLogo') ?? '').toString();
  if (!forceOverwrite && isUserUploadedStoreLogo(logo)) {
    return;
  }

  designForm.setValue('storeLogo', STORE_CHECKOUT_BRANDING.DEFAULT_FP_LOGO_SRC, {
    shouldDirty: true,
  });
  designForm.setValue('selectedColor', STORE_CHECKOUT_BRANDING.DEFAULT_FP_BRAND_COLOR, {
    shouldDirty: true,
  });
};

export const clearDefaultFreshPrintBrandingFromForm = (
  designForm: UseFormReturn<IDesignStoreFormShape>
): void => {
  const logo = (designForm.getValues('storeLogo') ?? '').toString().trim();
  if (!isDefaultFreshPrintStoreLogo(logo)) {
    return;
  }

  designForm.setValue('storeLogo', '', { shouldDirty: true });
  designForm.setValue('selectedColor', STORE_CHECKOUT_BRANDING.CUSTOM_BRANDING_DEFAULT_SWATCH, {
    shouldDirty: true,
  });
};
